import React, { useContext } from "react";
import { DataTable, HighlightMatch, OneLineShowMore, Table, Tooltip, ValueOrPlaceholder, } from "@sscs/ui";
import { capitalize } from "lodash";
import { useSearchParams } from "react-router";
import { FILE_BROWSER_ROUTES, REPORT_PAGES_ROUTES, TRANSFORM_LINKING, } from "../../../constants";
import { filteredByDependency } from "../../../store/sbomSlice";
import { expandedRowPaginationUpdated, selectExpandedRowPagination, selectReferenceName, } from "../../../store/vulnerabilitySlice";
import { BugInfo } from "../../../ui";
import { estimateTableHeight } from "../../../utils";
import { LinkToReportTab } from "../../common";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetVulnerabilityReferencesQuery } from "../../services/vulnerabilities.api";
import { generateFileBrowserLink, getQueryStatus } from "../../utils";
import styles from "./vulnerability.module.scss";
const COLUMNS = [
    { id: "type", label: "Type", width: "230px" },
    { id: "name", label: "Name", width: "40%" },
    { id: "path", label: "Path", width: "60%" },
    { id: "introduced", label: "Introduced in", width: "225px" },
    { id: "resolved", label: "Resolved in", width: "225px" },
    { id: "triage", label: "Triage", width: "200px" },
];
const VulnerabilityReferences = ({ id, cve, source_count, }) => {
    var _a;
    const [searchParams] = useSearchParams();
    const { reportId } = useContext(ReportContext);
    const dispatch = useReportDispatch();
    const pagination = useReportSelector((state) => selectExpandedRowPagination(state, id));
    const { data, isFetching, isLoading, isError, error } = useGetVulnerabilityReferencesQuery({
        ui_item_id: cve,
        ui_id: reportId,
        pagination,
    });
    const referenceName = useReportSelector(selectReferenceName);
    return (React.createElement(DataTable, { title: React.createElement("span", null,
            "Components and dependencies vulnerable to ",
            React.createElement("b", null, cve)), columns: COLUMNS, pagination: {
            itemCount: (_a = data === null || data === void 0 ? void 0 : data.match_count) !== null && _a !== void 0 ? _a : 0,
            pagination,
            onChange: (newPagination) => dispatch(expandedRowPaginationUpdated({ id: id, pagination: newPagination })),
        }, status: getQueryStatus({
            isLoading,
            isFetching,
            isError,
            error,
            data,
        }), style: data === undefined
            ? {
                // expanded row opens based on its height so we need to guess the height before data loads
                minHeight: estimateTableHeight(source_count),
            }
            : {} }, data === null || data === void 0 ? void 0 : data.references.map((item, index) => {
        var _a, _b;
        return (React.createElement(Table.Row, { hover: true, key: item.id },
            React.createElement(Table.Cell, null, item.linking
                ? TRANSFORM_LINKING[item.linking]
                : capitalize(item.type)),
            React.createElement(Table.Cell, null,
                React.createElement(Tooltip, { title: `View ${item.type.toLowerCase()} details` },
                    React.createElement("div", { className: styles["link-wrapper"] },
                        React.createElement(LinkToReportTab, { id: `${id}-link-${index}`, to: item.type === "DEPENDENCY"
                                ? REPORT_PAGES_ROUTES.SBOM_ROUTE
                                : generateFileBrowserLink({
                                    searchParams,
                                    componentPath: item.path,
                                    componentId: item.id,
                                    fileBrowserPage: FILE_BROWSER_ROUTES.VULNERABILITIES_ROUTE,
                                }), key: item.id, onClick: () => {
                                if (item.type === "DEPENDENCY") {
                                    dispatch(filteredByDependency({
                                        id: item.id,
                                        name: item.name,
                                    }));
                                }
                            }, color: "link", className: styles.link },
                            React.createElement(HighlightMatch, { value: item.display_name, regex: referenceName !== null && referenceName !== void 0 ? referenceName : "" }))))),
            React.createElement(Table.Cell, null, item.type === "COMPONENT" ? (React.createElement(OneLineShowMore, { value: item.path })) : (React.createElement(ValueOrPlaceholder, { value: item.path }))),
            React.createElement(Table.Cell, null,
                React.createElement(BugInfo, { bugInfo: item.introduced, bugType: "introduced" })),
            React.createElement(Table.Cell, null,
                React.createElement(BugInfo, { bugInfo: item.resolved, bugType: "resolved" })),
            React.createElement(Table.Cell, null, (_b = (_a = item.triage_outcome) === null || _a === void 0 ? void 0 : _a.split("-").map((part) => capitalize(part)).join(" ")) !== null && _b !== void 0 ? _b : "Not triaged")));
    })));
};
export default VulnerabilityReferences;
//# sourceMappingURL=VulnerabilityReferences.js.map